import { Box, Grid, SvgIcon } from "@material-ui/core";
import React from "react";
import { CheckCircleRounded, ErrorRounded, InfoRounded, WarningRounded } from "@material-ui/icons";
import { getContainerWidthsBySize } from "shared/helpers";
import { NoteProps } from "shared/interfaces/container/note/note";
import { useNoteGridStyles, useNoteIconStyles } from "./Note.styles";

const iconList = {
    info: InfoRounded,
    error: ErrorRounded,
    critical: ErrorRounded,
    warning: WarningRounded,
    success: CheckCircleRounded,
};

const Note = ({ variant, children, size = "auto", showStartIcon }: NoteProps): JSX.Element => {
    const gridStyles = useNoteGridStyles(getContainerWidthsBySize(size));
    const iconStyles = useNoteIconStyles();
    return (
        <Grid classes={{ ...gridStyles }} className={variant}>
            {showStartIcon && (
                <SvgIcon
                    component={iconList[variant]}
                    classes={{ ...iconStyles }}
                    className={variant}
                    viewBox="2 2 20 20"
                />
            )}
            <Box>{children}</Box>
        </Grid>
    );
};

export default Note;
